import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { MarketingWorkFileCard } from "./MarketingWorkFileCard";

export class MarketingWorkFile extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare problemHubId: number | null;
  declare name: string;
  declare title: string;
  declare archived: boolean;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "MarketingWorkFile";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "problemHubId", dataSource: "problem_hub_id", type: "number" },
      "name",
      "title",
      { name: "archived", type: "boolean", defaultValue: false },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }

  get displayName(): string {
    return this.name?.trim() || this.title?.trim() || "Untitled";
  }

  get problemHubRecord() {
    return this.project?.getCrudStore(STORE_KEYS.marketingTagStore)?.getById(this.problemHubId);
  }

  get workFileCards() {
    return this.project?.getCrudStore(STORE_KEYS.marketingWorkfileCardStore)?.query((r: MarketingWorkFileCard) => r.workFile === this.id);
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingWorkFile.exposeProperties();
